import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Waves, Droplets } from "lucide-react";

export function MobileFilterSheet({
  selectedState,
  setSelectedState,
  states,
  showRivers,
  setShowRivers,
  showLakes,
  setShowLakes,
  selectedPOITypes,
  setSelectedPOITypes,
  setShowPOIs,
  poiTypeConfig,
}) {
  return (
    <div className="py-4 space-y-6 overflow-y-auto max-h-[55vh]">
      {/* State Filter */}
      <div>
        <label className="text-sm font-medium mb-2 block">State</label>
        <Select value={selectedState} onValueChange={setSelectedState}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="All States" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All States</SelectItem>
            {states.map(state => (
              <SelectItem key={state} value={state}>{state}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      {/* Waterways */}
      <div>
        <label className="text-sm font-medium mb-2 block">Waterways</label>
        <label className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted cursor-pointer">
          <input
            type="checkbox"
            checked={showRivers}
            onChange={(e) => setShowRivers(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300"
          />
          <Waves className="w-4 h-4 text-cyan-500" />
          <span className="text-sm">Show Rivers & Streams</span>
        </label>
        <label className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted cursor-pointer">
          <input
            type="checkbox"
            checked={showLakes}
            onChange={(e) => setShowLakes(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300"
          />
          <Droplets className="w-4 h-4 text-cyan-500" />
          <span className="text-sm">Show Lakes & Reservoirs</span>
        </label>
      </div>

      {/* Points of Interest */}
      {poiTypeConfig.types.length > 0 && (
        <div>
          <label className="text-sm font-medium mb-2 block">Points of Interest</label>
          <div className="space-y-2">
            {Object.entries(poiTypeConfig.categories || {}).map(([categoryKey, categoryTypes]) => (
              <div key={categoryKey}>
                <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1 px-2">
                  {categoryKey.replace(/_/g, ' ')}
                </p>
                {categoryTypes.map(poiType => (
                  <label key={poiType.type} className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedPOITypes.includes(poiType.type)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedPOITypes(prev => [...prev, poiType.type]);
                          setShowPOIs(true);
                        } else {
                          const next = selectedPOITypes.filter(t => t !== poiType.type);
                          setSelectedPOITypes(next);
                          if (next.length === 0) setShowPOIs(false);
                        }
                      }}
                      className="w-4 h-4 rounded border-gray-300"
                    />
                    <span
                      className="w-3 h-3 rounded-full flex-shrink-0"
                      style={{ backgroundColor: poiType.color }}
                    />
                    <span className="text-sm">{poiType.label}</span>
                  </label>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
